import React from "react";

export default () => (
    <svg
        fill="currentColor"
        viewBox="0 0 26 26"
        enableBackground="new 0 0 26 26"
    >
        <path
            d="M 0.8125 0 A 1.0001 1.0001 0 0 0 0 1 L 0 16 A 1.0001 1.0001 0 0 0 1 17 L 9 17 L 9 25 A 1.0001 1.0001 0 0 0 10 26 L 25 26 A 1.0001 1.0001 0 0 0 26 25 L 26 10 A 1.0001 1.0001 0 0 0 25 9 L 17 9 L 17 1 A 1.0001 1.0001 0 0 0 16 0 L 1 0 A 1.0001 1.0001 0 0 0 0.90625 0 A 1.0001 1.0001 0 0 0 0.8125 0 z M 2 2 L 15 2 L 15 9.59375 L 14.28125 10.3125 L 15.6875 11.71875 L 16.40625 11 L 24 11 L 24 24 L 11 24 L 11 16.4375 L 11.75 15.6875 L 10.34375 14.28125 L 9.625 15 L 2 15 L 2 2 z M 5.8125 4.46875 L 4.40625 5.875 L 7.75 9.25 L 6 11 L 11 11 L 11 6 L 9.1875 7.8125 L 5.8125 4.46875 z M 13.15625 11.4375 L 11.5 13.0625 L 12.9375 14.46875 L 14.5625 12.84375 L 13.15625 11.4375 z M 15 15 L 15 20 L 16.75 18.25 L 20.125 21.59375 L 21.53125 20.1875 L 18.1875 16.8125 L 20 15 L 15 15 z"
            overflow="visible"
            enableBackground="accumulate"
            fontFamily="Bitstream Vera Sans"
        />
    </svg>
);
